import * as endpoints from "../../lib/api/endpoints";
import * as error from "../../lib/api/error";
import * as queryStringHelpers from "../../lib/queryStringHelpers";
import * as routes from "../../constants/routes";
import ActionButton, {ActionButtonStyle} from "../ActionButton";
import CardBanner from "../CardBanner";
import cn from "../../lib/classnames";
import ErrorBoundary from "../ErrorBoundary";
import Footer from "../Footer";
import getUserIds from "../../lib/getUserIds";
import logger from "../../lib/logger";
import moneyBag from "../../images/money-bag.svg";
import React, {useEffect, useRef, useState} from "react";
import referralClaimImage from "../../images/referral-claim.png";
import referralClaimImage2 from "../../images/referral-claim@2x.png";
import referralClaimImage3 from "../../images/referral-claim@3x.png";
import referralClaimImageDesktop from "../../images/referral-claim-desktop.png";
import referralClaimImageDesktop2 from "../../images/referral-claim-desktop@2x.png";
import referralClaimImageDesktop3 from "../../images/referral-claim-desktop@3x.png";
import ReviewCarousel from "../ReviewCarousel";
import RoundedCard from "../RoundedCard";
import SetNoIndex from "../../lib/SetNoIndex";
import styles from "./ReferralClaimPage.module.css";
import TextLink from "../TextLink";
import usePageView from "../../lib/usePageView";
import {Column, Container, Row} from "../grid";
import {carouselReviews} from "../../lib/carouselReviews";
import {RouteComponentProps} from "react-router-dom";

const strings = {
    agreement1:
        "By clicking the “Apply to Earn My Reward” button, I understand and agree that the 1st Financial Bank USA cardholder by whom I was referred will receive a",
    agreement2:
        "statement credit if I apply and am approved for a 1st Financial Bank USA credit card account and activate the card. I also acknowledge and confirm that I have read and agree to the Referred Friend Program ",
    applyFor: "Apply for a 1st Financial Bank USA",
    applyForRewards: "Apply to earn my reward!",
    creditCard:
        "credit card and if you are approved and activate your card, you will receive a $50 statement credit",
    forMoreDetails: " for more details",
    noThanks: "No Thanks",
    paidYou: "paid you!",
    referralClaimImage: "Referral Claim",
    seeTerms: "*See Referred Friend Program ",
    sentYou: "sent you an opportunity to earn",
    terms: "Terms and Conditions",
    title: "1FB USA Referral Claim",
    yourFriend: "Your friend",
};

const AUTO_SCROLL_TIME = 5000;

const REFERRAL_SOURCE = "RAF01";

const TERMS_LINK = "/referred_friend_program_terms_and_conditions.pdf";

function getReferralClaimImageDesktop() {
    return (
        <img
            className={styles.referralClaimImageDesktop}
            src={referralClaimImageDesktop}
            srcSet={`${referralClaimImageDesktop} 1x, ${referralClaimImageDesktop2} 2x, ${referralClaimImageDesktop3} 3x`}
            alt={strings.referralClaimImage}
        />
    );
}

function getReferralClaimImage() {
    return (
        <img
            className={styles.referralClaimImageMobile}
            src={referralClaimImage}
            srcSet={`${referralClaimImage} 1x, ${referralClaimImage2} 2x, ${referralClaimImage3} 3x`}
            alt={strings.referralClaimImage}
        />
    );
}

export default function ReferralClaimPage(props: RouteComponentProps) {
    const isMountedRef = useRef<boolean>(false);
    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        };
    }, []);

    useEffect(() => {
        document.title = strings.title;
    }, []);
    SetNoIndex();
    usePageView(strings.title);

    useEffect(() => {
        const qs = queryStringHelpers.objectify(window.location.search);
        if (qs.m !== "300") {
            endpoints
                .visit(
                    getUserIds().visitID,
                    document.documentURI,
                    navigator.userAgent,
                    document.referrer,
                )
                .catch((err) => error.reportAxios(err, "ReferralClaimPage"));
        }
    }, []);

    const [friendName, setFriendName] = useState("");
    const [amount, setAmount] = useState("");
    const [loadingReferral, setloadingReferral] = useState(false);

    const [loadingAccept, setLoadingAccept] = useState(false);
    const [disableAccept, setDisableAccept] = useState(false);
    const [loadingDecline, setLoadingDecline] = useState(false);
    const [disableDecline, setDisableDecline] = useState(false);
    const [clearInterval, setClearInterval] = useState(false);

    function redirectUser(route: string) {
        setClearInterval(true);
        if (!isMountedRef.current) {
            return;
        }
        const destination = `${process.env.REACT_APP_BASE_PATH}${route}${window.location.search}`;
        window.location.replace(destination);
    }

    const queryParams = queryStringHelpers.objectify(window.location.search);

    useEffect(() => {
        const qp = queryStringHelpers.objectify(window.location.search);
        if (!qp || !qp.rid) {
            redirectUser(routes.REFERRAL_ERROR);
        }
    }, []);

    useEffect(() => {
        setloadingReferral(true);
        const qp = queryStringHelpers.objectify(window.location.search);
        endpoints
            .viewedRedeemAFriend(qp.rid)
            .then((referral) => {
                if (!isMountedRef.current) {
                    return;
                }
                setFriendName(referral.referrerFirstName);
                setAmount(referral.recipientRewardAmount);
            })
            .catch((err) => {
                if (!isMountedRef.current) {
                    return;
                }
                logger.log(err);
                redirectUser(routes.REFERRAL_ERROR);
            })
            .finally(() => {
                if (!isMountedRef.current) {
                    return;
                }
                setloadingReferral(false);
            });
    }, []);

    function onRedeem(acceptMyReward: boolean) {
        endpoints
            .redeemAFriendDecision(acceptMyReward, queryParams.rid)
            .then(() => {
                if (!isMountedRef.current) {
                    return;
                }
                setClearInterval(true);
                const qp = queryStringHelpers.objectify(window.location.search);
                const paramsToStringify = {
                    ...qp,
                    source: REFERRAL_SOURCE,
                };
                const stringParams = queryStringHelpers.stringify(paramsToStringify);
                props.history.push(`${routes.ORGANIC_APP}${stringParams}`);
            })
            .catch((err) => {
                if (!isMountedRef.current) {
                    return;
                }
                logger.log(err);
                redirectUser(routes.REFERRAL_ERROR);
            })
            .finally(() => {
                if (!isMountedRef.current) {
                    return;
                }
                if (acceptMyReward) {
                    setLoadingAccept(false);
                    setDisableDecline(false);
                } else {
                    setLoadingDecline(false);
                    setDisableAccept(false);
                }
            });
    }

    function callLeadBeforeRedeem(acceptMyReward: boolean) {
        let fieldName = "";
        if (acceptMyReward) {
            setLoadingAccept(true);
            setDisableDecline(true);
            fieldName = "referral-redeem-accept";
        } else {
            setLoadingDecline(true);
            setDisableAccept(true);
            fieldName = "referral-redeem-declined";
        }
        endpoints
            .applicationLead(
                [
                    {
                        field: fieldName,
                        value: "",
                        timestamp: new Date().toISOString(),
                    },
                ],
                null,
                window.location.href,
            )
            .catch((err) => {
                error.reportAxios(err, "callApplicationLead");
            })
            .finally(() => {
                if (!isMountedRef.current) {
                    return;
                }
                onRedeem(acceptMyReward);
            });
    }

    function loadReferral(className?: string) {
        return (
            <div className={cn(styles.loadingReferral, className)}>
                <div className={cn(styles.loader, loadingReferral ? styles.visible : undefined)} />
            </div>
        );
    }

    return (
        <>
            <ErrorBoundary>
                <CardBanner
                    cardImage={getReferralClaimImageDesktop()}
                    logoClassName={styles.logo}
                    renderInterestRates={false}
                    renderOnlyCard={true}
                >
                    {!loadingReferral ? (
                        <>
                            <div className={styles.bannerTitle}>
                                {strings.yourFriend}
                                {` ${friendName} `}
                                {strings.sentYou}
                                {` $${amount}!`}
                            </div>
                            <div className={styles.bannerDescription}>
                                <b>{strings.applyFor}</b> {strings.creditCard}
                            </div>
                            {getReferralClaimImage()}
                            <div className={styles.cardContainer}>
                                <RoundedCard className={styles.card}>
                                    <div className={styles.transactionContainer}>
                                        <img
                                            className={styles.transactionImage}
                                            src={moneyBag}
                                            alt=""
                                        />
                                        <div
                                            className={styles.transactionAmount}
                                        >{`+${amount}.00*`}</div>
                                    </div>
                                </RoundedCard>
                            </div>
                            <div className={styles.disclaimerText}>
                                {strings.seeTerms}
                                <TextLink
                                    className={styles.disclaimerTextLink}
                                    text={strings.terms}
                                    to={TERMS_LINK}
                                />
                                {strings.forMoreDetails}
                            </div>
                        </>
                    ) : (
                        loadReferral(styles.loadingBanner)
                    )}
                </CardBanner>
                <div className={styles.reviewCarouselContainer}>
                    <Container>
                        <Row>
                            <Column largeOffset={1} large={10} medium={8}>
                                <ReviewCarousel
                                    reviews={carouselReviews}
                                    windowClassName={styles.reviewCarouselWindow}
                                    clearInterval={clearInterval}
                                    autoScrollTimeMilli={AUTO_SCROLL_TIME}
                                />
                            </Column>
                        </Row>
                    </Container>
                </div>
                <Container className={styles.container}>
                    <Row>
                        <Column largeOffset={2} large={8} mediumOffset={1} medium={6}>
                            {!loadingReferral ? (
                                <>
                                    <div className={styles.agreementText}>
                                        {strings.agreement1}
                                        {` $${amount} `}
                                        {strings.agreement2}
                                        <TextLink
                                            className={styles.textLink}
                                            text={strings.terms}
                                            to={TERMS_LINK}
                                        />
                                        {"."}
                                    </div>
                                </>
                            ) : (
                                loadReferral(styles.loadingAgreement)
                            )}
                        </Column>
                    </Row>
                    <Row>
                        <Column largeOffset={4} large={4} mediumOffset={2} medium={4}>
                            <div className={styles.buttonContainer}>
                                <ActionButton
                                    className={styles.applyForRewardsButton}
                                    label={strings.applyForRewards}
                                    loading={loadingAccept}
                                    onClick={() => callLeadBeforeRedeem(true)}
                                    style={ActionButtonStyle.secondary}
                                    disabled={loadingReferral || disableAccept}
                                />
                                <ActionButton
                                    className={styles.noThanksButton}
                                    label={strings.noThanks}
                                    loading={loadingDecline}
                                    onClick={() => callLeadBeforeRedeem(false)}
                                    style={ActionButtonStyle.outlined}
                                    disabled={loadingReferral || disableDecline}
                                />
                            </div>
                        </Column>
                    </Row>
                </Container>
                <Footer />
            </ErrorBoundary>
        </>
    );
}
